module.exports = "./assets/images/pic2.jpeg";